import React from 'react';

export const SkeletonLine = ({ className = '' }) => (
  <div className={`animate-pulse bg-card-hover rounded ${className}`} />
);

export const SkeletonCard = () => (
  <div className="card p-5 space-y-3 animate-pulse">
    <SkeletonLine className="h-4 w-2/5" />
    <SkeletonLine className="h-3 w-3/5" />
    <SkeletonLine className="h-8 w-1/3 mt-2" />
  </div>
);

export const SkeletonTable = ({ rows = 5 }) => (
  <div className="card overflow-hidden animate-pulse">
    <div className="p-4 border-b border-border flex gap-6">
      <SkeletonLine className="h-3 w-20" />
      <SkeletonLine className="h-3 w-24" />
      <SkeletonLine className="h-3 w-16" />
      <SkeletonLine className="h-3 w-28" />
    </div>
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="p-4 border-b border-border flex gap-6">
        <SkeletonLine className="h-3 w-24" />
        <SkeletonLine className="h-3 w-20" />
        <SkeletonLine className="h-3 w-16" />
        <SkeletonLine className="h-3 w-32" />
      </div>
    ))}
  </div>
);

export const SkeletonDashboard = () => (
  <div className="space-y-8 animate-pulse">
    <div>
      <SkeletonLine className="h-7 w-48" />
      <SkeletonLine className="h-4 w-32 mt-2" />
    </div>
    <div className="grid grid-cols-2 gap-4">
      <SkeletonCard />
      <SkeletonCard />
    </div>
    <div className="space-y-3">
      <SkeletonLine className="h-3 w-28" />
      <SkeletonCard />
      <SkeletonCard />
    </div>
  </div>
);

export const SkeletonProjectTab = () => (
  <div className="space-y-4 animate-pulse">
    <div className="flex items-center justify-between">
      <SkeletonLine className="h-5 w-40" />
      <SkeletonLine className="h-8 w-24 rounded-lg" />
    </div>
    <div className="space-y-3">
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </div>
  </div>
);

export const SkeletonProjectDetail = () => (
  <div className="space-y-6 animate-pulse">
    <div className="flex items-center gap-4">
      <SkeletonLine className="h-5 w-5 rounded" />
      <SkeletonLine className="h-7 w-56" />
    </div>
    <div className="flex gap-2">
      {Array.from({ length: 5 }).map((_, i) => (
        <SkeletonLine key={i} className="h-9 w-20 rounded-lg" />
      ))}
    </div>
    <SkeletonProjectTab />
  </div>
);

export const PageLoader = () => (
  <div className="flex items-center justify-center min-h-[60vh]">
    <div className="w-8 h-8 border-4 border-accent/30 border-t-accent rounded-full animate-spin" />
  </div>
);
